import { useQuery } from "@tanstack/react-query";
import CashierApi from "../../utility/CashierApi";

// Shares its cache key with the template query in Payment, so the receipt
// template is only fetched once.
function useReceiptTemplate() {
  const { fetchOnlyData } = CashierApi();

  const { data } = useQuery({
    queryKey: ["template"],
    queryFn: () => fetchOnlyData("receipt-template"),
    retry: 1,
    staleTime: 30 * 60 * 1000,
    cacheTime: 60 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  return data;
}

export default useReceiptTemplate;
